import React from 'react';
import ensureTranslations from '%app/js/common/services/translationLoader';
import mountReactRoot from '%app/js/common/services/mountReactRoot';
import Page from './component/Page';

const CONTAINER_ID = 'base-react-root';

window.addEventListener('load', () => {
    if (!document.getElementById(CONTAINER_ID)) {
        return;
    }

    ensureTranslations('PayseraServiceAgreementBundle').then(() => {
        mountReactRoot(CONTAINER_ID, <Page />);
    });
});
